import { api } from '@/service/http';

export const getOkved = async () => {
    try {
        const { result, items } = await api('counteragent./nsi/okved/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'c15e7d8a-3e9f-4efa-bb1a-dee0a24e32d5',
        };
    }
};

export const getOkvedResolution = async () => {
    try {
        const { result, items } = await api('counteragent./nsi/okved-resolution/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'a639b38d-a2fa-418c-b364-f3835d605979',
        };
    }
};
export const getMinistry = async () => {
    try {
        const { result, items } = await api('counteragent./nsi/ministry/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'e735732f-ae97-4f4c-93fe-3f5a1da91731',
        };
    }
};

export const getFs = async () => {
    try {
        const { result, items } = await api('counteragent./nsi/fs/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '7ca8db2b-8b29-4e92-a60a-5fddd23be99b',
        };
    }
};

export const getBusin = async () => {
    try {
        const { result, items } = await api('counteragent./nsi/busin/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '65eee8bd-57e6-46dd-a624-442d1fb5dbfe',
        };
    }
};

export const getCls = async () => {
    try {
        const { result, items } = await api('counteragent./nsi/cls/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'd51dc857-9617-4214-bfde-a5f852c66e58',
        };
    }
};

export const getOrgseparator = async () => {
    try {
        const { result, items } = await api('counteragent./nsi/orgseparator/list/get', {});
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '29d31d23-75b6-45d2-8640-1c4f39719c2a',
        };
    }
};

export const getCustomerCard = async id => {
    try {
        const { result, rows } = await api('counteragent./customer/card/get', { id });
        if (!result) {
            return {
                result: false,
                error: 'database result: false',
                uuid: '1dd504a9-e551-4796-8f7a-5fe35607c9b8',
            };
        }
        return {
            result: true,
            data: rows,
        };
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'f70731da-1e54-4ab1-9c7c-51e54bdc14cf',
        };
    }
};

export const saveCustomerCard = async args => {
    try {
        const response = await api('counteragent./customer/card/save', args);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '2b7ea1cd-9a74-44c3-bc25-64aea87294bc',
        };
    }
};

const getValidateResponse = response => {
    if (response.result) {
        if (response.data) {
            return {
                result: response.result,
                success: !!response.result,
                data: response.data, //data может быть объектом или массивом
            };
        } else if (response.items) {
            return {
                result: response.result,
                success: !!response.result,
                data: response.items, //data может быть объектом или массивом
            };
        }
    } else {
        return {
            result: response.result ? response.result : false,
            errors: {
                message: response.msg.message ? response.msg.message : response.msg,
            },
            uuid: response.uuid ? response.uuid : 'e89d1ee4-e075-4367-8ec5-f0655201e2bc',
        };
    }
};

export const getNotebook = async kodp => {
    try {
        const response = await api('counteragent./customer/card/widget/notebook/get', { id: kodp });
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '9cda024e-1724-4ed5-aa54-dec913a83276',
        };
    }
};

export const getArea = async () => {
    try {
        const response = await api('counteragent./customer/dict/area/get', null);
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5f701d3a-1041-4313-9d59-168bbb25226d',
        };
    }
};

export const getStatus = async () => {
    try {
        const response = await api('counteragent./customer/dict/status/get', null);
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4a63e15a-b201-4d5f-801f-340d8cf86e79',
        };
    }
};

export const getDep = async () => {
    try {
        const response = await api('counteragent./customer/dict/dep/get', null);
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'a584f3e2-8242-4dc5-8d6c-25001d73b2b7',
        };
    }
};

export const getDolzhfun = async () => {
    try {
        const response = await api('counteragent./customer/dict/dolzhfun/get', null);
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '48098b77-88de-4da8-88f0-04d14fbfa027',
        };
    }
};

export const getNamedolzh = async () => {
    try {
        const response = await api('counteragent./customer/dict/namedolzh/get', null);
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '8dee1478-5462-4376-8bdd-54acac7fed47',
        };
    }
};

export const getChief = async () => {
    try {
        const response = await api('counteragent./customer/card/widget/employee/get', null);
        if (response.result) {
            response.data.forEach(row => {
                if (row.kod_dolzhfun === 14) {
                    return {
                        value: 'Руководитель',
                        name: row.fio,
                    };
                }
            });
            return {
                value: 'Руководитель',
                name: 'не задан',
            };
        }
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'cd17d247-e099-49be-a98b-f2faf627034b',
        };
    }
};

export const getOkvedRazdel = async () => {
    try {
        const response = await api('counteragent./customer/dict/okved-razdel/get', null);
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'c22614c6-1b17-4bbd-a205-c35ff388a278',
        };
    }
};

export const getOkveds = async () => {
    try {
        const response = await api('counteragent./customer/dict/okveds/get', null);
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '1bdabbd5-cc89-448c-8f3f-d528aceac03c',
        };
    }
};

export const getObjectCard = async kod_numobj => {
    try {
        const response = await api('object./object/card/get', { kod_numobj });
        return getValidateResponse(response);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'ec082fc7-b26a-4d01-ac5d-dbec003fb922',
        };
    }
};

export const updObjectCard = async args =>{
    try {
        return await api('object./object/card/upd', args);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '62b2381d-2989-4c9f-a6b5-30cc20f72fac',
        };
    }
}

export const insObjectCard = async args =>{
    try {
        return await api('object./object/card/ins', args);
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '3d1f6402-18dc-4490-a0d7-eea424a5f2e5',
        };
    }
}
